import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Button from "./Button";
import StepHeader from "./checkout/StepHeader";
import { breakpoints } from "../utils/styles";
import FullColumnLayout from "./FullColumnLayout";
import { getSelectedCinema } from "../reducers";
import { CinemaType } from "../types/entities";
import FieldRow from "./FieldRow";
import { cinemaSelectorOpen } from "../actions/creators/ui";
import { AnalyticsCandybar } from "../utils/analytics";

const Container = styled.div`
    padding: var(--pad-x);

    & > p { margin: 3rem 0; }
`;

const Content = styled.div`
    max-width: 500px;
    margin: 0 auto;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        text-align: center;
    }
`;

const Text = styled.p`
    font-size: 1.2rem;
    text-align: center;
`;

const Emoji = styled.span`
    font-size: 2.5rem;
    display: block;
    margin: 0 auto 1rem;
    font-family: "Noto Color Emoji", sans-serif;
`;

function CandybarLandingPage() {
    return <FullColumnLayout Content={PageContentConnected} />;
}

interface Props {
    defaultCinema: CinemaType | null;
    cinemaSelectorOpen: () => void;
}

class PageContent extends React.Component<Props> {
    componentDidMount() {
        AnalyticsCandybar.trackSectionEntry(false);
    }

    render() {
        const cinemaId = this.props.defaultCinema ? this.props.defaultCinema.id : null;

        return <Container>
            <StepHeader label="Dulcería" to="/" stepIndicator={false}/>
            <Content>
                <Emoji>🍿</Emoji>
                <Text className='mb-5'>Elige qué deseas hacer y selecciona el complejo donde recibirás tus alimentos.</Text>
                <FieldRow label="Tu cine" value={this.props.defaultCinema ? this.props.defaultCinema.name : 'Selecciona un cine'} onClick={this.props.cinemaSelectorOpen}/>
                <Button block primary to={cinemaId ? `/dulceria/compra/cine-${cinemaId}` : undefined} className="mb-3" disabled={!cinemaId}>Quiero ordenar</Button>
                <Button block to="/usuario/mis-compras/dulceria" className="mb-3">Ver mis pedidos</Button>
            </Content>
        </Container>;
    }
}

const mapStateToProps = (state) => ({
    defaultCinema: getSelectedCinema(state),
});

const mapDispatchToProps = (dispatch) => ({
    cinemaSelectorOpen: () => dispatch(cinemaSelectorOpen()),
});

const PageContentConnected = connect(
    mapStateToProps,
    mapDispatchToProps
)(PageContent);

export default CandybarLandingPage;
